import { Clock, Mail, MapPin, MessageCircle, Phone } from 'lucide-react';
import PageHero from '@/components/site/PageHero';
import EnquiryForm from '@/components/site/EnquiryForm';
import { useCompany, usePage } from '@site/content';

export default function Contact() {
  const { hero, form } = usePage('contact');
  const company = useCompany();

  const cards = [
    { icon: Phone, title: 'Call us', lines: [{ text: company.phone, href: company.phoneHref }, { text: company.phone2, href: company.phone2Href }] },
    {
      icon: Mail,
      title: 'Email',
      lines: [company.email, company.email2, company.email3].filter(Boolean).map((e) => ({ text: e, href: `mailto:${e}` })),
    },
    { icon: MapPin, title: 'Visit', lines: [{ text: company.address, href: company.mapLink, external: true }] },
    { icon: Clock, title: 'Working hours', lines: [{ text: company.days }, { text: company.hours }] },
  ];

  return (
    <>
      <PageHero {...hero} seoTitle="Contact" />

      <section className="py-16 sm:py-24">
        <div className="site-container grid gap-10 lg:grid-cols-[1fr_1.3fr] lg:gap-14">
          <div className="space-y-4">
            {cards.map(({ icon: CardIcon, title, lines }) => (
              <div key={title} className="flex gap-4 rounded-2xl border border-[var(--app-border)] bg-white p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                  <CardIcon className="h-5 w-5" aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <h2 className="text-xl text-ink-950">{title}</h2>
                  {lines.map((l) =>
                    l.href ? (
                      <a key={l.text} href={l.href} {...(l.external ? { target: '_blank', rel: 'noreferrer' } : {})} className="block break-words text-sm leading-relaxed text-ink-600 hover:text-primary-700">
                        {l.text}
                      </a>
                    ) : (
                      <p key={l.text} className="text-sm leading-relaxed text-ink-600">{l.text}</p>
                    ),
                  )}
                </div>
              </div>
            ))}
            <a
              href={company.whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-5 py-4 font-medium text-white transition-opacity hover:opacity-90"
            >
              <MessageCircle className="h-5 w-5" aria-hidden="true" /> Chat on WhatsApp
            </a>
          </div>
          <EnquiryForm title={form.title} description={form.text} />
        </div>
      </section>

      <section aria-label="Map" className="h-[24rem] w-full bg-ink-100">
        <iframe
          title={`Map showing ${company.name}`}
          src={company.mapEmbed}
          className="h-full w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>
    </>
  );
}
